import React from 'react'

export default function QuoteCircle({ color, backgroundColor }) {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50" fill={backgroundColor} />
      <path
        d="M31 64.8209V55.0187C31 52.4415 31.2301 50.0485 31.6903 47.8396C32.2425 45.6306 33.1169 43.4677 34.3134 41.3507C35.602 39.1418 37.2587 37.0249 39.2836 35L44.6679 39.0037C43.1032 40.7525 41.8607 42.4092 40.9403 43.9739C40.0199 45.5386 39.3756 47.0572 39.0075 48.5298C38.6393 50.0025 38.4552 51.5211 38.4552 53.0858L35.1418 50.7388H45.0821V64.8209H31ZM53.9179 64.8209V55.0187C53.9179 52.4415 54.148 50.0485 54.6082 47.8396C55.1604 45.6306 56.0348 43.4677 57.2313 41.3507C58.5199 39.1418 60.1766 37.0249 62.2015 35L67.5858 39.0037C66.0211 40.7525 64.7786 42.4092 63.8582 43.9739C62.9378 45.5386 62.2935 47.0572 61.9254 48.5298C61.5572 50.0025 61.3731 51.5211 61.3731 53.0858L58.0597 50.7388H68V64.8209H53.9179Z"
        fill={color}
      />
    </svg>
  )
}
